import { useState } from "react";

import MonthCalendar from "./components/monthCalendar";
import NextSchedulings from "./components/nextSchedulings";
import Schedule from "./components/schedule";
import ServiceBayScheduleDialog from "./components/schedule/dialogs/ServiceBayScheduleDialog";

import { getFirstDayOfWeek, getLastDayOfWeek } from "../../../../utils/dateUtils";
import { Loading } from "../../../../utils/loading";

import ServiceBayList from "./components/serviceBayList";
import useServiceBay from "../../../../hooks/useServiceBay";
import { ServiceBay, ServiceBaySchedule } from "../../../../models/serviceBay";
import { useMediaQuery } from "@mui/material";

export type ScheduleViewType = "month" | "week" | "day";

const ServiceBayControl = (props: any) => {

  const {
    loading,
    currentDate,
    setCurrentDate,
    todaySchedule,
    tomorrowSchedule,
    scheduleServiceBays,
    serviceBays,
    serviceBayIdsSelected,
    setServiceBayIdsSelected,
    save,
    remove,
    scheduleServiceBay,
    occurrences,
    occurrencePage,
    occurrenceLoading,
    occurrenceHasMoreData,
    getOccurrences,
    unscheduleServiceBay,
   } = useServiceBay();

  const [scheduleSidebar, setScheduleSidebar] = useState(true);
  const [scheduleViewType, setScheduleViewType] = useState<ScheduleViewType>("week");
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [schedule, setSchedule] = useState<ServiceBaySchedule | undefined>(undefined);
  const isResponsiveView = useMediaQuery('(max-width: 1024px)');
  
  return (
    <>
      {loading ? (
        <Loading label="Carregando agenda..." />
      ) : (
        <>
          <div className="text-size-18 text-bold padding-y-10">
            Agenda de controle de Box
          </div>
          <div className="panel panel-default panel-body shadow-default padding-0">
              <div className={`${isResponsiveView ? 'display-flex flex-direction-column' : 'display-flex gap-10'}`}>
                {isResponsiveView && scheduleSidebar && (
                  <div className="mobile-calendar-container">
                    <div className="mobile-calendar-centered">
                      <MonthCalendar
                        dayChoosed={currentDate}
                        chooseDay={setCurrentDate}
                      />
                    </div>
                    <NextSchedulings
                      todaySchedule={todaySchedule}
                      tomorrowSchedule={tomorrowSchedule}
                    />
                    <ServiceBayList
                      serviceBays={serviceBays}
                      serviceBayIdsSelected={serviceBayIdsSelected}
                      selectServiceBay={(serviceBayId) => {
                        setServiceBayIdsSelected((prev) => {
                          if (prev.includes(serviceBayId)) {
                            return prev.filter((id) => id !== serviceBayId);
                          }
                          return [...prev, serviceBayId];
                        });
                      }}
                      onCreateServiceBay={async (name) => await save({ name } as ServiceBay)}
                      onRemoveServiceBay={remove}
                    />
                  </div>
                )}
                {scheduleSidebar && !isResponsiveView && (
                <div className="flex-basis-250">
                  <MonthCalendar
                    dayChoosed={currentDate}
                    chooseDay={setCurrentDate}
                  />
                  <NextSchedulings
                    todaySchedule={todaySchedule}
                    tomorrowSchedule={tomorrowSchedule}
                  />
                  <ServiceBayList
                    serviceBays={serviceBays}
                    serviceBayIdsSelected={serviceBayIdsSelected}
                    selectServiceBay={(serviceBayId) => {
                      setServiceBayIdsSelected((prev) => {
                        if (prev.includes(serviceBayId)) {
                          return prev.filter((id) => id !== serviceBayId);
                        }
                        return [...prev, serviceBayId];
                      });
                    }}
                    onCreateServiceBay={async (name) => await save({ name } as ServiceBay)}
                    onRemoveServiceBay={remove}
                  />
                </div>
              )}

                <div
                  style={{
                    borderLeftWidth: !isResponsiveView && scheduleSidebar ? 1 : 0,
                    borderTopWidth: isResponsiveView && scheduleSidebar ? 1 : 0
                  }}
                  className="width-100pct"
                >
                <Schedule
                  serviceBays={
                    serviceBays.filter((serviceBay) => serviceBayIdsSelected.includes(serviceBay.id ?? ""))
                  }
                  firstWeekDay={getFirstDayOfWeek(currentDate)}
                  lastWeekDay={getLastDayOfWeek(currentDate)}
                  consultantMonthSchedule={scheduleServiceBays}
                  currentDate={currentDate}
                  setCurrentDate={setCurrentDate}
                  handleScheduleSidebar={() =>
                    setScheduleSidebar(!scheduleSidebar)
                  }
                  scheduleViewType={scheduleViewType}
                  setScheduleViewType={setScheduleViewType}
                  onCreateSchedule={() => setShowScheduleModal(true)}
                  setSchedule={setSchedule}
                  goToDate={setCurrentDate}
                />
              </div>
            </div>
          </div>

          <ServiceBayScheduleDialog
            scheduleServiceBays={scheduleServiceBays}
            initialData={schedule}
            serviceBays={serviceBays}
            isOpen={showScheduleModal}
            onClose={() => {
              setShowScheduleModal(false);
              setSchedule(undefined);
            }}
            onSave={scheduleServiceBay}
            onDelete={unscheduleServiceBay}
            occurrences={occurrences}
            occurrencePage={occurrencePage}
            occurrenceLoading={occurrenceLoading}
            occurrenceHasMoreData={occurrenceHasMoreData}
            getOccurrences={getOccurrences}
          />
        </>
      )}
    </>
  );
};

export default ServiceBayControl;
